import { gql } from '@apollo/client';

export const GET_LISTING_AMOUNT_DISTRIBUTION_PER_PUBBLICATION_DATE = gql`
  query getListingAmountDistributionPerPublicationDate($vendorNames: [String!]!, $country: Country) {
    getListingAmountDistributionPerPublicationDate(input: { vendorNames: $vendorNames, country: $country }) {
      publicationDateWeekRangeISO8601
      amountOfListingsPerPeriod
    }
  }
`;
